import React, { useEffect, useState } from "react";
import modalBorder from "@assets/images/borders/modalBorder.webp";
import contactBorder from "@assets/images/borders/contactBorder.webp";
import type { IDeleteConfirmation } from "@src/types/AppTypes";

const DeleteConfirmation = React.memo(
  React.forwardRef<HTMLDivElement, IDeleteConfirmation>(
    ({ setModal, title, headTitle, isPassWay = true }, ref) => {
      const [isLoading, setIsLoading] = useState<boolean>(false);

      const [scrollPosition, setScrollPosition] = useState(0);

      useEffect(() => {
        const header = document.getElementById("header");
        const footer = document.getElementById("footer");
        const currentScrollY = window.scrollY;
        setScrollPosition(currentScrollY);

        if (header) {
          header.style.zIndex = "0";
        }
        if (footer) {
          footer.style.zIndex = "-1";
        }
        document.body.style.overflow = "hidden";
        document.body.style.top = `-${currentScrollY}px`;
        document.body.style.position = "fixed";
        document.body.style.width = "100%";

        return () => {
          // Enable background scroll
          if (isPassWay) document.body.style.overflow = "auto";
          document.body.style.position = "";
          document.body.style.width = "";
          window.scrollTo(0, scrollPosition);

          if (header) {
            header.style.zIndex = "";
          }
          if (footer) {
            footer.style.zIndex = "";
          }
        };
      }, [isPassWay]);

      return (
        <div className="max-w-2xl w-full bg-gradient-to-b from-[#1D1159] to-[#00AEEF] relative rounded-[5px_10px_20px_0px] text-black modal-content delete-modal-content">
          <img
            src={modalBorder}
            className="absolute top-0 left-0 size-full z-[0]"
            alt="modal border"
          />
          <div
            ref={ref}
            className={`fixed size-full bg-[#00000080] top-0 left-0 grid place-items-center z-[999]`}
          >
            <div
              className={
                "relative bg-gradient-to-b rounded-[2rem_4rem_4rem_4rem] max-w-md w-full from-[#1D1159] to-[#00AEEF]"
              }
              id={title}
              onAnimationEnd={() => {
                document.getElementById(title)?.classList.remove("form-shake");
              }}
            >
              <div className="relative p-10 max-xl:p-6">
                <img
                  className="absolute top-0 left-0 size-full"
                  src={contactBorder}
                  alt=""
                />
                <div className="relative">
                  <div className="flex items-center justify-between mb-4 gap-10">
                    <h2 className="text-primary text-xl">
                      {headTitle ? headTitle : ""}
                    </h2>
                    <button
                      onClick={() => {
                        setModal(false);
                      }}
                      className="text-primary text-3xl ml-auto duration-150 hover:scale-95"
                      aria-label="close"
                    >
                      <i className="ri-close-circle-line"></i>
                    </button>
                  </div>
                  <p className="text-3xl text-white text-center">{title}</p>
                  <div className="mt-5 flex items-end max-md:flex-col justify-center gap-3">
                    <button
                      className="z-10 w-full text-lg customized-button"
                      onClick={async () => {
                        setModal(false);
                      }}
                      aria-label="cancle"
                    >
                      Cancel
                    </button>
                    <button
                      disabled={isLoading}
                      className="flex justify-center z-10 w-full text-lg customized-button"
                      onClick={async () => {
                        setIsLoading(true);
                        setModal(true);
                        setIsLoading(false);
                      }}
                      aria-label="save"
                    >
                      {isLoading ? (
                        <i className="ri-loop-right-line btn-loader"></i>
                      ) : (
                        "Confirm"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  )
);

export default DeleteConfirmation;
